"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPACE_BACKGROUND_IMAGE_FALLBACK_URL = void 0;
exports.SPACE_BACKGROUND_IMAGE_FALLBACK_URL = "https://cdn.gather.town/v0/b/gather-town.appspot.com/o/manually-uploaded%2Ferr.png?alt=media&token=1572eac5-12e9-485c-9999-c5d35dda6002";
//# sourceMappingURL=spaceConstants.js.map